import { useState, useCallback } from "react";

/**
 * Custom hook: Form state management with validation
 */
export const useForm = (initialValues, onValidate) => {
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});

  const setValue = useCallback((newValues) => {
    setValues((prev) => ({ ...prev, ...newValues }));
  }, []);

  const reset = useCallback(() => {
    setValues(initialValues);
    setErrors({});
  }, [initialValues]);

  const validate = useCallback(() => {
    const errs = onValidate(values);
    setErrors(errs);
    return Object.keys(errs).length === 0;
  }, [values, onValidate]);

  return {
    values,
    setValues: setValue,
    errors,
    setErrors,
    reset,
    validate,
    isValid: Object.keys(errors).length === 0,
  };
};

/**
 * Custom hook: Modal/Dialog state
 */
export const useModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);

  const open = useCallback((id = null) => {
    setEditingId(id);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    setEditingId(null);
  }, []);

  return {
    isOpen,
    setIsOpen,
    editingId,
    setEditingId,
    open,
    close,
  };
};
